import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GooglePlacesAutocompleteDirective } from './google-places-autocomplete.directive';

@NgModule({
  declarations: [GooglePlacesAutocompleteDirective], // ✅ Declare the pipe here
  imports: [CommonModule], // ✅ Import CommonModule if required
  exports: [GooglePlacesAutocompleteDirective], // ✅ Export the pipe for use in other modules
})
export class GoogleAddressModule {}
